import { ISubmitResponse } from '../../../../../../../../types/shared/PrequalificationDataEntry';
import SessionStorage from '../../../../../../../../utils/SessionStorage';
import { AcquisitionFlow, callDataExposureApi } from '../../../../../../../../utils/acquisition-utils';
import { usePageProperties } from '../../../../../../providers/PagePropertiesProvider';

export default function usePrequalMultiAccount() {
    const { pqHomeRedirectUrl, multiAcctErrorCode } = usePageProperties();

    const multiAccountFlow = (data: ISubmitResponse) => {
        SessionStorage.remove('prequalResponse');
        SessionStorage.setObjectWithCurrentScope(
            'prequalResponseMultiAccount',
            data,
        );
        callDataExposureApi(AcquisitionFlow.PQ).then(() => {
            const params = new URLSearchParams(window.location.search);
            params.set('errorCode', multiAcctErrorCode);
            window.location.assign(
                pqHomeRedirectUrl + '.html?' + params.toString(),
            );
        });
    };

    return {
        multiAccountFlow,
    };
}
